import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export function formatDateTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatCurrency(amount) {
  if (!amount && amount !== 0) return '';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
}

export function truncate(str, length = 50) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

export function getInitials(nom, prenom) {
  const n = nom ? nom.charAt(0).toUpperCase() : '';
  const p = prenom ? prenom.charAt(0).toUpperCase() : '';
  return n + p || '??';
}

export const DOMAINES_JURIDIQUES = [
  { value: 'civil', label: 'Droit Civil' },
  { value: 'penal', label: 'Droit Pénal' },
  { value: 'commercial', label: 'Droit Commercial' },
  { value: 'travail', label: 'Droit du Travail' },
  { value: 'administratif', label: 'Droit Administratif' },
  { value: 'famille', label: 'Droit de la Famille' },
];

export const STATUTS_AFFAIRE = [
  { value: 'en_cours', label: 'En cours' },
  { value: 'cloture', label: 'Clôturé' },
  { value: 'archive', label: 'Archivé' },
];

export const TYPES_CLIENT = [
  { value: 'particulier', label: 'Particulier' },
  { value: 'entreprise', label: 'Entreprise' },
];

export const TYPES_ECHEANCE = [
  { value: 'delai', label: 'Délai légal' },
  { value: 'rdv', label: 'Rendez-vous' },
  { value: 'paiement', label: 'Paiement' },
  { value: 'audience', label: 'Audience' },
];

export const TYPES_AUDIENCE = [
  { value: 'mise_en_etat', label: 'Mise en état' },
  { value: 'plaidoirie', label: 'Plaidoirie' },
  { value: 'delibere', label: 'Délibéré' },
];

export const MODES_RECHERCHE = [
  { value: 'rapide', label: 'Recherche rapide' },
  { value: 'approfondi', label: 'Analyse approfondie' },
  { value: 'jurisprudence', label: 'Jurisprudence' },
  { value: 'legislation', label: 'Législation' },
  { value: 'complet', label: 'Mode complet' },
];
